export default __webpack_public_path__ + "static/media/apenasLogo.beb7ee4e.svg";